export var EBtnTypeAnalytics = /*#__PURE__*/function (EBtnTypeAnalytics) {
  EBtnTypeAnalytics["popular"] = "start_button";
  EBtnTypeAnalytics["replies"] = "script_button";
  return EBtnTypeAnalytics;
}({});